import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { CLIENT_CLASSIFICATION, GET_CLIENT_INSURERS, MEMBER_COVERAGES_COUNT } from "../../../../../utils/data/models";
import { bindActionCreators } from "redux";
import CategorisationForm from "./CategorisationForm";
import { RectangleSpinner } from "../../../../common/spinners";
import * as dataActions from "../../../../../utils/data/dataActions";
import { FormattedMessage } from "react-intl";
import simpleFetch from "../../../../../../utils/simpleFetch";
import englishTranslations from "../../../../../components/intl/en-CA";
import frenchTranslations from "../../../../../components/intl/fr-CA";
import { EN } from "../../../../common/enums/languages";

class Categorisation extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.getData = this.getData.bind(this);
        this.setInitialValuesIsSet = this.setInitialValuesIsSet.bind(this);
        this.getCalculatedMemberCount = this.getCalculatedMemberCount.bind(this);
        this.getCalculatedInsurerField = this.getCalculatedInsurerField.bind(this);

        this.state = {
            fetching: true,
            clientClassification: null,
            initialValuesIsSet: false,
        };

    }

    componentWillMount() {
        this.getData();
    }

    setInitialValuesIsSet(value) {
        this.setState({ initialValuesIsSet: value });
    }

    async getCalculatedMemberCount() {
        const path = MEMBER_COVERAGES_COUNT.path.replace("{}", this.props.clientId);
        const now = new Date();
        const formattedDate = now.toISOString().split("T")[0];
        const filterStr = `members.isArchived==false;memberCoverages.isInactive==false;memberCoverages.startDate<=${formattedDate};(memberCoverages.endDate==null,memberCoverages.endDate>=${formattedDate})`;

        const res = await simpleFetch("GET", path, {
            query: { filters: filterStr },
        });

        return res;
    }

    async getCalculatedInsurerField() {
        const { clientId } = this.props;
        const path = GET_CLIENT_INSURERS.path.replace("{}", clientId);
        const userLanguage = localStorage.getItem("languageCode") || EN.value;

        const res = await simpleFetch("GET", path, {
            query: { filters: `clientId==${clientId};isArchived==false` },
        });

        let insurerFieldValue = "";

        if (res) {
            const translationFile = userLanguage == "fr-CA" ? frenchTranslations : englishTranslations;
            if (res.length > 1) {
                insurerFieldValue =
                    translationFile.clients.client.categorisation.categoryForm.form.insurerTypes.multiInsurers;
            } else if (res.length === 1) {
                insurerFieldValue = res[0].localizations[userLanguage].name;
            } else {
                insurerFieldValue =
                    translationFile.clients.client.categorisation.categoryForm.form.insurerTypes.noInsurers;
            }
        }

        return insurerFieldValue;
    }

    getData(cb = null) {
        const { clientId, dataActions } = this.props;
        const model = {
            ...CLIENT_CLASSIFICATION,
            path: CLIENT_CLASSIFICATION.path.replace("{}", clientId),
        };
        dataActions.getDataItem(model, "").then(async (res) => {
            let { data } = res.payload;

            delete data.createdAt;
            delete data.updatedAt;

            data.vipClient = !!(data && data.vipClassification);

            const calculatedMemberCount = await this.getCalculatedMemberCount();
            data.numberOfMembers = calculatedMemberCount;

            const calculatedInsurerFieldValue = await this.getCalculatedInsurerField();
            data.insurers = calculatedInsurerFieldValue;

            this.setState({ fetching: false, initialValues: data }, () => {
                this.setState({ initialValuesIsSet: true });
                if (cb) {
                    cb(data);
                }
            });
        });
    }

    render() {
        const { fetching, initialValues, initialValuesIsSet } = this.state;
        const { clientId } = this.props;
        return !fetching ? (
            <div>
                <h4>
                    <span className="required"> * </span>
                    <span className="gray-label-color">
                        <FormattedMessage id="clients.client.categorisation.requiredInfo" />
                    </span>
                </h4>
                <CategorisationForm
                    initialValues={initialValues}
                    clientId={clientId}
                    getData={this.getData}
                    initialValuesIsSet={initialValuesIsSet}
                    setInitialValuesIsSet={this.setInitialValuesIsSet}
                />
            </div>
        ) : (
            <RectangleSpinner className="spinner-rect-col" />
        );
    }
}

Categorisation.propTypes = {
    clientId: PropTypes.number,
    dataActions: PropTypes.object,
};

function mapDispatchToProps(dispatch) {
    return {
        dataActions: bindActionCreators(dataActions, dispatch),
    };
}

function mapStateToProps(state) {
    const { clientId } = state.data.clients.active;

    return {
        clientId: clientId,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Categorisation);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/categorisation/Categorisation.js